/**
 * This file is the App entrypoint for admin embeds, etc
 */

import { AppProvider } from '@shopify/polaris';

import React from 'react';
import { Route, BrowserRouter, Routes, Navigate } from 'react-router-dom';

import { NavMenu } from '@shopify/app-bridge-react';

import LocationIndexPage from './pages/LocationIndexPage';
import LocationDetailsPage from './pages/LocationDetailsPage';
import CategoryMappingPage from './pages/CategoryMappingPage';

function GetApp() {
    return function App() {
        return (
            <React.StrictMode>
                <NavMenu>
                    <a rel="home" href="/locations">
                        Retail Locations
                    </a>
                </NavMenu>
                <AppProvider>
                    <BrowserRouter>
                        <Routes>
                            <Route path="/" element={<Navigate to="/locations" />} />
                            <Route path="/locations">
                                <Route index element={<LocationIndexPage />} />
                                <Route path=":id" element={<LocationDetailsPage />} />
                            </Route>
                            <Route path="/category-mappings" element={<CategoryMappingPage />} />
                        </Routes>
                    </BrowserRouter>
                </AppProvider>
            </React.StrictMode>
        );
    };
}

export default GetApp;
